module.exports = __webpack_public_path__ + "static/media/yellow.563d488c.png";